import { getBase64Cookie, setBase64Cookie } from './utils';

document.addEventListener('DOMContentLoaded', () => {
  const lang = getBase64Cookie('lang');
  console.debug('Current lang cookie is', lang);
  const languageSwitchers = document.querySelectorAll('.js-language-switcher');

  // Grab all language switchers (if more than one on the page)
  languageSwitchers.forEach((languageSwitcher) => {
    // Grab all the language buttons
    const links = languageSwitcher.querySelectorAll('.language-btn');
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.target as HTMLAnchorElement;
        const lang = target.dataset.lang;
        if (lang) {
          // Add the lang param to the current page URL and navigate there
          // const url = new URL(window.location.href);
          // url.searchParams.set('lang', lang);
          // window.location.href = url.toString();

          // Just set the cookie and reload the page and it should redirect...
          setBase64Cookie('lang', lang);
          console.debug('Set lang cookie to', lang);
          window.location.reload();
        }
      });
    });
  });
});
